import { useContext } from 'react'
import { Box, Button, Typography } from '@mui/material'

import { DataContext } from '../../contexts/data/dataContext'
import custom from '../../styles/mui/szVariables.json'

export default function DirectDebitPopup({ onContinue }: any) {
  const data = useContext(DataContext)

  return (
    <>
      {data?.directDebit?.error ?
        <Box display="flex" 
            flexDirection="column" 
            alignItems="center"
            justifyContent={"center"} 
            alignContent={"center"}
            maxWidth="100%"
            p={custom.spacing.md}>
            <Box ml={custom.spacing.xxs} 
              mb={custom.spacing.sm} 
              component={'img'} 
              id="error-icon" 
              alt="Error icon" 
              src="/images/Error.svg" />
            <Typography 
                  textAlign="center"  
                  mb={custom.spacing.sm} 
                  variant="szHeading.Bold.xxSmall">
              Direct debit setup encountered an error
            </Typography>
            <Typography textAlign="center" 
              variant="szBody.Regular.Small">
              {data?.directDebit?.error}
            </Typography>
  
            <Box width="100%" py={custom.spacing.sm}>
              <Button
                sx={{ p: custom.spacing.sm }}
                id="errorDirectDebit"
                color="primary"
                fullWidth
                onClick={()=>onContinue(1)}
                variant="contained">
                Try again
              </Button>
            </Box>
        </Box>
      :
        <Box display="flex" 
            flexDirection="column" 
            alignItems="center"
            justifyContent={"center"} 
            alignContent={"center"}
            maxWidth="100%"
            p={custom.spacing.md}>
            <Box ml={custom.spacing.xxs} 
              mb={custom.spacing.sm} 
              component={'img'} 
              id="check-icon" 
              alt="Check icon" 
              src="/images/CheckIcon.svg" />
            <Typography 
                  textAlign="center"  
                  mb={custom.spacing.sm} 
                  variant="szHeading.Bold.xxSmall">
              Direct debit setup successfully
            </Typography>
            <Typography textAlign="center" 
              variant="szBody.Regular.Small">
              SolarZero will send you details of this authority within the next 5 business days. 
              If you have any questions, please contact us on  <a href="tel:0800116655" 
                  style={{ textDecoration: 'none'}}>
                    0800 11 66 55
              </a>
            </Typography>

            <Box width="100%" py={custom.spacing.sm}>
              <Button
                sx={{ p: custom.spacing.sm }}
                id="successDirectDebit"
                color="primary"
                fullWidth
                onClick={onContinue}
                variant="contained">
                Got it
              </Button>
            </Box>
        </Box>
      }
    </>  
  )
}
